<template>
  <div v-loading="loading">
    <div class="w-full flex justify-between">
      <span class="text-xl">User - List</span>
      <div class="flex">
        <button
          class="bg-blue-500 text-white rounded-full px-3 select-none"
          @click="
            dialogFormVisible = true
            clearForm()
            formState = 'create'
          "
        >
          <i class="el-icon-plus"></i>
          Create
        </button>
        <div
          class="w-8 h-8 flex rounded-full border items-center justify-center ml-2 cursor-pointer hover:bg-gray-200 select-none"
          @click="reload()"
        >
          <i class="el-icon-refresh"></i>
        </div>
      </div>
    </div>
    <hr class="my-2" />
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :line-numbers="true"
      compactMode
      :sort-options="{ enabled: true }"
      styleClass="vgt-table bordered striped condensed"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 10
      }"
    >
      <template slot="table-row" slot-scope="props">
        <span :id="`${props.column.field}-${props.index}`" class="text-xs">
          {{ props.formattedRow[props.column.field] }}
        </span>
        <div v-if="props.column.field == 'action'" class="flex justify-around">
          <div
            class="hover:bg-gray-200 rounded-full w-6 h-6 flex justify-center items-center cursor-pointer tooltip"
            @click="openEdit(props.index)"
          >
            <i class="el-icon-edit-outline"></i>
          </div>
          <div
            class="hover:bg-gray-200 rounded-full w-6 h-6 flex justify-center items-center cursor-pointer tooltip"
            @click="remove(props.index)"
          >
            <i class="el-icon-delete"></i>
          </div>
        </div>
      </template>
    </vue-good-table>

    <el-dialog title="User Form" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form" size="mini">
        <el-form-item label="Username" class="font-bold">
          <el-input
            v-model="form.username"
            autocomplete="off"
            :disabled="isUsernameDisable"
          ></el-input>
        </el-form-item>
        <el-form-item label="Full Name" class="font-bold">
          <el-input v-model="form.fullName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email" class="font-bold">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="Password" class="font-bold" v-if="!isPasswordDisable"> -->
        <el-form-item label="Password" class="font-bold">
          <el-input
            v-model="form.password"
            autocomplete="off"
            show-password
            placeholder="Fill to create new password"
          ></el-input>
        </el-form-item>
        <el-form-item label="Role" class="font-bold">
          <el-select
            v-model="form.roles"
            multiple
            :multiple-limit="1"
            placeholder="Select"
            class="w-full"
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button
          v-if="formState === 'create'"
          type="primary"
          @click="
            dialogFormVisible = false
            add()
          "
          >Save</el-button
        >
        <el-button
          v-else
          type="primary"
          @click="
            dialogFormVisible = false
            update()
          "
          >Update</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  username: 'my-component',
  data() {
    return {
      isUsernameDisable: false,
      isPasswordDisable: false,
      dialogFormVisible: false,
      loading: false,
      roleOptions: [],
      form: {
        id: 0,
        username: '',
        email: '',
        fullName: '',
        password: '',
        roles: []
      },
      columns: [
        {
          label: 'Username',
          field: 'Username',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Full Name',
          field: 'Fullname',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Email',
          field: 'Email',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: '',
          field: 'action',
          sortable: false,
          width: '100px'
        }
      ],
      rows: [],
      isAdmin: this.$store.state.auth.isAdmin,
      formState: 'create'
    }
  },
  mounted() {
    this.fetchData()
    this.fetchRoles()
  },
  methods: {
    clearFilter(field) {
      try {
        let found = this.columns.find((c) => {
          return c.field == field
        })
        found.filterOptions.filterValue = ''
      } catch {
        alert(`Unable to clear ${field} filter`)
      }
    },
    changeFilter(field, newFilter) {
      let found = this.columns.find((c) => {
        return c.field == field
      })
      if (found) {
        if (found.hasOwnProperty('filterOptions')) {
          if (found.filterOptions.hasOwnProperty('filterValue')) {
            found.filterOptions.filterValue = newFilter
          } else {
            alert(`Column '${field}' does not have filterValue property!`)
          }
        } else {
          alert(`Column '${field}' does not have filtering configured!`)
        }
      } else {
        alert(`Field '${field}' does not exist!`)
      }
    },
    clearForm() {
      this.isUsernameDisable = false
      this.isPasswordDisable = false

      this.form = {
        id: 0,
        username: '',
        fullName: '',
        email: '',
        password: '',
        roles: []
      }
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    async fetchData() {
      try {
        this.showLoading()

        const res = await this.$axios.get('User/GetAll')
        this.rows = res.data

        this.hideLoading()
      } catch (e) {
        this.hideLoading()
        console.log(e)
      }
    },
    reload() {
      this.fetchData()
    },
    openEdit(indexOfData) {
      this.formState = 'edit'

      const data = this.rows[indexOfData]

      this.form = {
        id: data.Id,
        username: data.Username,
        fullName: data.Fullname,
        email: data.Email,
        password: '',
        roles: data.RolesName
      }

      this.isUsernameDisable = true
      this.isPasswordDisable = true
      this.dialogFormVisible = true
    },
    async add() {
      try {
        this.showLoading()

        const data = {
          Username: this.form.username,
          FullName: this.form.fullName,
          Email: this.form.email,
          Password: this.form.password,
          RolesName: this.form.roles
        }

        await this.$axios.post('User/Post', data)

        // Reset form data
        this.clearForm()

        this.reload()
      } catch (err) {
        console.log(err)
        this.hideLoading()
      }
      this.hideLoading()
    },
    async update() {
      try {
        this.showLoading()

        const data = {
          Id: this.form.id,
          Username: this.form.username,
          FullName: this.form.fullName,
          Email: this.form.email,
          RolesName: this.form.roles
        }

        // if password isn't empty, change it by set the password
        if (this.form.password !== '') data.Password = this.form.password

        await this.$axios.put('User/Put', data)

        // Reset form data
        this.clearForm()

        this.reload()
      } catch (err) {
        console.log(err)
        this.hideLoading()
      }
      this.hideLoading()
    },
    async remove(indexOfData) {
      var isConfirmed = confirm('Are you sure want to delete the item')
      if (isConfirmed == true) {
        this.showLoading()

        const data = this.rows[indexOfData]
        try {
          await this.$axios.delete(`User/Delete?id=${data.Id}`)

          this.reload()
        } catch (err) {
          console.log(err)
          this.hideLoading()
        }

        this.hideLoading()
      }
    },
    async fetchRoles() {
      try {
        const res = await this.$axios.get('Roles/GetAll')

        this.roleOptions = res.data.map((item) => {
          return {
            value: item.RoleName,
            label: item.RoleLabel
          }
        })
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
